import {
  PixelAdapter,
  GoogleAdapter,
  MoengageAdapter,
  PostHogAdapter,
} from "../adapters";

/**
 * Initialize the event tracking system with the provided adapters
 * @param adapters Array of tracking adapters to register
 */
export async function initializeEventTracking(
  adapters: import("./subscriber").TrackingAdapter[]
): Promise<void> {
  // Import the subscriber
  const { eventSubscriber } = await import("./subscriber");

  // Register each adapter using for...of instead of forEach
  for (const adapter of adapters) {
    eventSubscriber.registerAdapter(adapter);
  }

  // Initialize the subscriber
  await eventSubscriber.initialize();
}

/**
 * Example initialization function with common adapters
 * This is a convenience function that shows how to set up common tracking adapters
 * Users can customize this based on their needs
 */
export async function initTracking(config: {
  pixelId?: string;
  gaId?: string;
  moengageAppId?: string;
  moengageRegion?: string;
  enableDebugLogs?: boolean;
}) {
  console.log("Initializing event tracking system...");

  const adapters = [];

  // Facebook Pixel
  if (config.pixelId) {
    const pixelAdapter = new PixelAdapter({
      pixelId: config.pixelId,
    });
    adapters.push(pixelAdapter);
  }

  // Google Analytics
  if (config.gaId) {
    const gaAdapter = new GoogleAdapter({
      measurementId: config.gaId,
    });
    adapters.push(gaAdapter);
  }

  // MoEngage
  if (config.moengageAppId) {
    const moengageAdapter = new MoengageAdapter({
      appId: config.moengageAppId,
      enableUserIdentification: true,
      region: config.moengageRegion || "dc_01",
      debug: config.enableDebugLogs || false,
    });
    adapters.push(moengageAdapter);
  }

  // PostHog
  const posthogAdapter = new PostHogAdapter({
    enableDebugLogs: config.enableDebugLogs || false,
  });
  adapters.push(posthogAdapter);

  console.log(
    "Configured adapters:",
    adapters.map((a) => a.name)
  );

  await initializeEventTracking(adapters);
  console.log("Event tracking system initialized successfully");
}
